import React from 'react';
type Align = 'left' | 'right' | 'center';
const alignClass: Record<Align, string> = {
  left: 'text-left',
  right: 'text-right',
  center: 'text-center'
};
interface CellProps {
  children?: React.ReactNode;
  align?: Align;
  className?: string;
  colSpan?: number;
}
export function Th({
  children,
  align = 'left',
  className = ''
}: Omit<CellProps, 'colSpan'>) {
  return <th scope="col" className={`whitespace-nowrap border-b border-sf-border bg-sf-bg px-3 py-2 text-xs font-semibold leading-4 text-[#444444] ${alignClass[align]} ${className}`} data-id="element-807" data-mp="hsh1rwlhy76s">
      {children}
    </th>;
}
export function Td({
  children,
  align = 'left',
  className = '',
  colSpan
}: CellProps) {
  return <td colSpan={colSpan} className={`border-b border-sf-border px-3 py-2 text-[13px] ${alignClass[align]} ${align === 'right' ? 'whitespace-nowrap tabular-nums' : ''} ${className}`} data-id="element-808" data-mp="mrbhgpo63fmo">
      {children}
    </td>;
}